/**
 * Created by xuyq on 2021/1/8.
 */
import chatbot from './view/chatbot/index.vue'
import { mdiAccountBoxMultipleOutline } from '@mdi/js'
import store from './store'

export default () => {
  let menu = [
    {
      component: chatbot,
      path: '/',
      name: 'chatbot',
      title: 'chatbot',
      icon: mdiAccountBoxMultipleOutline,
      meta: {
        layout: 'black',
      },
    },
  ]

  return {
    menu,
    store,
  }
}
